import { CommonSelectOption, OptionTypeOfSurgicalHistory } from 'components/medicalHistory/types/types';

export const getAutoCompleteDisable = (
  option: OptionTypeOfSurgicalHistory[],
  inputValue: OptionTypeOfSurgicalHistory[],
  item: OptionTypeOfSurgicalHistory,
): boolean => {
  const match = inputValue.find((iv) => iv.value === item.value);
  return !!option.find((i) => i.value === match?.value);
};

export function removeItemFromList(
  prev: CommonSelectOption[],
  item: CommonSelectOption,
): {items: CommonSelectOption[], isEmpty: boolean} {
  const items = prev.filter((i) => i.value !== item.value);
  return { items, isEmpty: !items.length };
}
/*
    These organizations will be skip the insurance page.
    Id: 4, Name: Dallas Direct Podiatry
    Id: 13 Name: Colorado Foot & Ankle Wellness
    Id: 227937002 -> qa org
*/
export const organizationIds = new Set([4, 13, 227937002]);

export const skipInsuranceScreen = (
  organizationId: number,
  pageNumber: number,
) => organizationIds.has(organizationId) && pageNumber === 4;
